import { jsx as _jsx } from "react/jsx-runtime";
import MainPage from "../../components/MainPage";
const Home = () => _jsx(MainPage, {});
export default Home;
